import { Box, createStyles } from '@mantine/core';
import { EntityType } from '@repo/common/enums/entityType';
import { useMemo } from 'react';
import {
	fetchCatalogList,
	useCatalogList,
} from '../../../api/hooks/resourceCatalog';
import { useCatalogFilter } from '../../../components/Filter/useCatalogFilter';
import { TableV2 } from '../../../components/TableV2';
import { useDataQualityScoreColumns } from '../../../components/TableV2/SecodaEntity.hooks';
import {
	useActions,
	useColumns,
} from '../../TeamCatalogPage/TeamCatalogPage.hooks';

const WITH_CUSTOM_PROPERTIES = [EntityType.table];

interface ITablesTabProps {
	jobId: string;
}

const useStyles = createStyles({
	tableWrapper: {
		height: '100%',
	},
});

function TablesTab({ jobId }: ITablesTabProps) {
	const { classes } = useStyles();

	const defaultColumns = useColumns();
	const dataQualityColumns = useDataQualityScoreColumns({
		catalogType: EntityType.table,
	});

	const columns = useMemo(
		() => [...defaultColumns, ...dataQualityColumns],
		[dataQualityColumns, defaultColumns]
	);

	const actions = useActions();

	const filterOptions = useCatalogFilter();

	const defaultRequiredCatalogFilters = useMemo(
		() => ({
			operands: [
				{
					operands: [],
					field: 'parent_id',
					operator: 'exact' as const,
					value: jobId,
				},
			],
		}),
		[jobId]
	);

	return (
		<Box className={classes.tableWrapper}>
			<TableV2
				withCustomProperties={WITH_CUSTOM_PROPERTIES}
				pluralTypeString="tables"
				withSearch
				withInteractiveHeader
				withServerCsvExport
				withCsvExport
				withCheckbox
				withActions={actions}
				withFilterOptions={filterOptions}
				columns={columns}
				fetchPaginationList={fetchCatalogList}
				usePaginationList={useCatalogList}
				columnVisibility={{
					catalogType: EntityType.table,
					catalogServerType: EntityType.table,
				}}
				defaultRequiredSearchParams={{
					entity_type: EntityType.table,
				}}
				defaultRequiredCatalogFilters={defaultRequiredCatalogFilters}
			/>
		</Box>
	);
}

export default TablesTab;
